import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	endStandupButton: {
		id: 'standups.control-buttons.end-standup-button.end-standup-button',
		defaultMessage: 'End stand-up',
		description: 'Text on button for users to leave a stand-up happening at the moment',
	},
});
